import { isNullOrEmpty } from "../formValidation";
import {
    ADLoginUserInformation,
    ILocalStorage,
    ObjectClaimUserInfo,
    ObjectCreator,
    ObjectRequester
} from "./LocalStorage.interface";

export const getCompanyCode = (): string => {
    return localStorage.getItem('company_code')!
}

export const getObjectCreator = (): ObjectCreator => {
    return JSON.parse(localStorage.getItem('objCreator')!)
}

export const getLanguageCode = (): string => {
    return localStorage.getItem('language_code')!
}

export const getEmployeeId = (): string => {
    return localStorage.getItem('employee_id')!
}

export const getObjectRequester = (): ObjectRequester => {
    // return !isNullOrEmpty(localStorage.getItem('objRequestor')) ? JSON.parse(localStorage.getItem('objRequestor')!) : null;
    return JSON.parse(localStorage.getItem('objRequestor')!);
}

export const getObjectClaimUserInfo = (): any => {
    return !isNullOrEmpty(localStorage.getItem('objClaimUserInfo')) ? JSON.parse(localStorage.getItem('objClaimUserInfo')!) : null;
}

export const getObjectAttachment = ():any => {
    return !isNullOrEmpty(localStorage.getItem('objAttachment')) ? JSON.parse(localStorage.getItem('objAttachment')!) : null;
}

export const getOS = ():any => {
    return localStorage.getItem('OS') ? localStorage.getItem('OS') : "";
}

export const getEnvironment = ():any => {
    return localStorage.getItem('Environment') ? localStorage.getItem('Environment') : "";
}

export const getADLoginUserInformation = (): ADLoginUserInformation => {
    return JSON.parse(localStorage.getItem('ADLoginUserInformation')!)
}

export const getCountryCode = (): string => {
    return localStorage.getItem('country_code')!
}

export const getUserName = (): string => {
    return localStorage.getItem('UserName')!
}

export const getToken = (): string => {
    return localStorage.getItem('token')!
}

export const getUserRoles = (): string[] => {
    return localStorage.getItem('RoleChecking') ? JSON.parse(localStorage.getItem('RoleChecking')!) as string[] : [];
}

export const LocalStorage: ILocalStorage = {
    setItem: <T>(key: string, value: T) => {
        try {
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
        } catch (error) {
            console.error(`Error setting item ${key} in localStorage`, error);
        }
    },
    getItem: <T>(key: string): T | null => {
        try {
            const serializedValue = localStorage.getItem(key);
            if (serializedValue === null) {
                return null;
            }
            return JSON.parse(serializedValue) as T;
        } catch (error) {
            console.error(`Error getting item ${key} from localStorage`, error);
            return null;
        }
    },
    removeItem: (key: string): void => {
        localStorage.removeItem(key);
    }
};

export default LocalStorage;